import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Armchair, X } from "lucide-react";

export function SitInvite({ onSit, onDismiss }) {
  // after 12s without sitting, the bench invitation breathes softly
  const [pulse, setPulse] = useState(false);
  useEffect(() => {
    const id = setTimeout(() => setPulse(true), 12000);
    return () => clearTimeout(id);
  }, []);
  return (
    <motion.div
      data-testid="sit-invite"
      data-pulse={pulse ? "1" : "0"}
      initial={{ opacity: 0, y: -14 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 1.2, delay: 1.2, ease: "easeOut" }}
      style={{ x: "-50%" }}
      className="fixed bottom-24 [.walkpad_&]:bottom-[calc(env(safe-area-inset-bottom)+11.25rem)] [.walkpad_&]:md:bottom-auto left-1/2 z-[46] flex items-center gap-1 rounded-full border border-white/80 bg-white/75 p-1.5 shadow-[0_18px_40px_-18px_rgba(91,58,133,0.55)] backdrop-blur-xl md:bottom-auto md:top-24"
    >
      <button data-testid="sit-invite-accept" onClick={onSit} className={`flex items-center gap-3 whitespace-nowrap rounded-full px-4 py-2 transition-colors duration-300 hover:bg-[#F3E8FF] ${pulse ? "bench-pulse" : ""}`}>
        <Armchair size={16} className="text-[#7E57C2]" />
        <span className="font-display text-lg italic text-[#2D1E3E]">Take a seat on the bench.</span>
        <span className="hidden font-display text-sm italic text-[#7C6992] sm:inline">The memories begin in a moment.</span>
      </button>
      <button data-testid="sit-invite-dismiss" aria-label="Not now" onClick={onDismiss} className="rounded-full p-2 text-[#7C6992] transition-colors hover:text-[#7E57C2]">
        <X size={14} />
      </button>
    </motion.div>
  );
}

